// Copyright (c) 2016 Deere & Company

import Product, {getDefaultState as getProductDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product';
import actions from '../../../action-list';
import {getDefaultState} from '../state';

const resetProductDetails = () => getProductDefaultState();

const updateProductDetails = (state, action) =>
    Product.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().product, action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_MCC_FOLLOWUP]: resetProductDetails,
        [actions.RESET_CLAIM_MCC_FOLLOWUP_PRODUCT_DETAILS]: resetProductDetails,
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_PRODUCT_DETAILS]: updateProductDetails
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/reducers/product-details.js